/**
 * Created by fengqian_pc on 2017/12/13.
 */
let isMobile = (function() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
})();

let DY = {
  // baseUrl: 'http://115.29.202.161:18082/api/',  //测试
  // baseUrl:'http://115.29.202.161:18082/api/',  //晓楠
  // baseUrl:'http://115.29.202.161:18089/api/',  //会涛
  // baseUrl:'http://115.29.202.161:18085/api/',  //扛把子
  // baseUrl:'http://115.29.202.161:12983/api/',  //林军
  baseUrl: '//ow.dailyyoga.com.cn/api/', //线上
  // baseUrl: '//owqa.dailyyoga.com.cn/api/', //测试
  // baseUrl: '//owmirror.dailyyoga.com.cn/api/', //mirror
  web_product_activity_id: 70,
  // payVip:'http://text.dailyyoga.com.cn/front_end_all/o2/coursePay/index.html',  //ceshi
  // vipUrl:'http://text.dailyyoga.com.cn/front_end_all/o2/coursePay/vipContent.html', //web_product_activity_id=69&payType=2
  // o2Url:'http://text.dailyyoga.com.cn/front_end_all/o2/coursePay/o2Content.html',  //session_id=33&payType=1
  payVip: 'https://o2o.dailyyoga.com.cn/front_end_all/o2/coursePay/index.html',
  vipUrl:
    'https://o2o.dailyyoga.com.cn/front_end_all/o2/coursePay/vipContent.html', //web_product_activity_id=69&payType=2
  o2Url: 'https://o2o.dailyyoga.com.cn/o2_detail/', //session_id=33&payType=1
  isMobile: isMobile,
  downloadUrl:
    'https://a.app.qq.com/o/simple.jsp?pkgname=com.dailyyoga.cn&from=singlemessage&isappinstalled=1',
};

export default DY;



// WEBPACK FOOTER //
// ./src/assets/js/common.js